import { useQuery } from "@tanstack/react-query";
import { PagedResultWithExtra } from "models/common";
import { useAuthenticatedRequest } from "./useRequests";

export enum NotificationTopic {
    Unknown = 0,
    Individual = 1,
    Announcement = 2,
    Breakers = 3,
    VIPs = 4,
}

export interface NotificationBody {
    text: string | null;
    html: string | null;
}

export interface Notification {
    id: string;
    title: string;
    topic: NotificationTopic;
    body: NotificationBody;
    timestamp: string;
    seen: boolean;
    data: Record<string, string> | null;
}

export interface NotificationExtra {
    unreadCount: number;
}

export type NotificationPagedResponse = PagedResultWithExtra<
    Notification,
    NotificationExtra
>;

const useDeviceNotifications = (enabled: boolean = true) => {
    const getData = useAuthenticatedRequest<NotificationPagedResponse>({
        url: "/device/notifications?page=1",
        method: "GET",
    });

    return useQuery(["deviceNotifications"], getData, { enabled });
};

export default useDeviceNotifications;
